<template>
  <b-modal ref="hand-baggage-modal-ref" hide-footer title="Hand Baggage Information">
    <div v-if="baggage">
      <span class="baggage-info"
        >Your hand baggage allowance is listed below per person. Please scroll down to see the
        allowance for all flights on your itinerary - this may differ between flights. Please note that baggage allowances do not show for any flights not yet booked. It is displayed in weight, dimensions and
        number of permitted bags where applicable.
      </span>
      <br />
      <br />
      <span class="baggage-info"
        >Please also note that some transfers and/or tours have luggage restrictions on them such as seaplanes and overland adventures. Please see your itinerary for specific details and take this into consideration when packing.
      </span>
      <br />
      <div v-if="flightsArr.length > 0" class="d-flex expand-collapse-container">
        <button class="vtd-btn mt-3" @click="toggleExpandAll">
          {{ buttonText }}
        </button>
      </div>

      <div v-if="flightsArr.length === 0">
        <p class="mt-3">No flights found for your booking</p>
      </div>
      <div v-for="(flight, index) in flightsArr" :key="index">
        <HandBaggageDay
          :id="flight.flightno"
          :flight="flight"
          :flight-no="flight.flightno"
          :itinerary="matchingItinerary(flight.flightno, flight.galLocator, flight.deptime)"
          :baggage="matchingBaggage(flight.flightno, flight.depdate)"
          :dropdown-prop="checkDates(index)"
          :expand-all-prop="expandAll" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import HandBaggageDay from './day'

export default {
  components: {
    HandBaggageDay,
  },
  props: {
    itineraryArr: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      flightNo: '',
      displaySelected: 'ALL',
      expandAll: false,
    }
  },
  computed: {
    ...mapGetters({
      baggage: 'baggage/getBaggage',
    }),
    buttonText() {
      return this.expandAll ? 'Close All' : 'Expand All'
    },
    flightsArr() {
      let arr = []
      let dupeHandBaggObj = {}
      this.baggage.checked.forEach((item) => {
        let { galLocator } = item
        item.flights.forEach((flight) => {
          const matchingItinItem = this.matchingItinerary(
            flight.flightno,
            galLocator,
            flight.deptime
          )
          flight.depdate = matchingItinItem.depdate
          if (
            !dupeHandBaggObj[`${flight.flightno}`] ||
            (dupeHandBaggObj[`${flight.flightno}`] &&
              (dupeHandBaggObj[`${flight.flightno}`].deptime !== flight.deptime ||
                dupeHandBaggObj[`${flight.flightno}`].vendorloc !== matchingItinItem.vendorloc))
          ) {
            dupeHandBaggObj[`${flight.flightno}`] = { deptime: '', vendorloc: '' }
            dupeHandBaggObj[`${flight.flightno}`].deptime = flight.deptime
            dupeHandBaggObj[`${flight.flightno}`].vendorloc = matchingItinItem.vendorloc
            arr.push(flight)
          }
        })
      })
      // sort the resulting array by depdate
      arr.sort((a, b) => {
        const dateA = new Date(a.depdate)
        const dateB = new Date(b.depdate)
        // if two dates are the same, compare flights by deptime
        if (dateA.getTime() === dateB.getTime()) {
          const timeA = new Date(a.deptime)
          const timeB = new Date(b.deptime)
          return timeA.getTime() - timeB.getTime()
        } else {
          // otherwise, compare by date
          return dateA.getTime() - dateB.getTime()
        }
      })
      return arr
    },
    baggageArr() {
      const flatBaggageArr = []
      let dupeArr = []
      this.baggage.hand.forEach((item) => {
        if (item.baggageItem) {
          flatBaggageArr.push(item)
        } else {
          flatBaggageArr.push({
            flights: [],
            pieces: 'No checked baggage',
          })
        }
      })
      return flatBaggageArr
    },
  },
  mounted() {
    this.$nextTick(function () {
      if (this.$refs.itineraryItemRef && this.$refs.itineraryItemRef[0]) {
        this.$refs.itineraryItemRef[0].toggleExpand()
      }
    })
    this.$refs['hand-baggage-modal-ref'].$on('hide', this.onHide)
  },
  methods: {
    showModal(flightNo) {
      if (flightNo) this.flightNo = flightNo
      this.$refs['hand-baggage-modal-ref'].show()
      if (flightNo) {
        setTimeout(() => {
          document.getElementById(flightNo).scrollIntoView({ block: 'start', behavior: 'smooth' })
        }, 1200)
      }
    },
    onHide() {
      setTimeout(() => {
        this.expandAll = false
      }, 400)
    },
    checkItineraryDay(types, type) {
      if (type === 'ALL') {
        return true
      } else {
        if (types.indexOf(type) > -1) {
          return true
        }
      }
    },
    matchingItinerary(flightNo, galLocator, departureTime) {
      const matchingItems = this.itineraryArr.filter((item) => {
        const _values = Object.values(item)
        return _values.includes(galLocator) && _values.includes(flightNo)
      })
      if (matchingItems.length === 1) {
        return matchingItems[0]
      } else if (!matchingItems.length) {
        return {}
      }
      // else, more than 1 flight with the same flight number and gal locator (e.g. BA2159 LGW-UVF-GND. The flight touches down in St Lucia (UVF) and then continues to Grenada. Same flight number.)
      // so, match by departure time as well
      const correctFlight = matchingItems.find((item) => {
        let _formattedDepTime = item.deptime.replace(':', '').trim()
        return _formattedDepTime === departureTime.trim()
      })
      return correctFlight ? correctFlight : matchingItems[0]
    },
    matchingBaggage(flightNo, depDate) {
      const matchingBaggageItem = this.baggageArr.find((item) => {
        return Object.values(item.flights).includes(flightNo)
      })
      return matchingBaggageItem ? matchingBaggageItem.baggageItem : {}
    },
    checkDates(index) {
      const today = new Date().getTime()
      const depDates = this.itineraryArr.map((item) => {
        return Date.parse(item.depdate)
      })
      // if holiday has not yet begun, open first dropdown
      if (today < depDates[0] && index === 0) {
        return true
      } else if (today >= depDates[0]) {
        // if holiday has begun, open dropdowns programatically
        let count = 0
        for (let i = 0; i < depDates.length; i++) {
          if (today > depDates[i]) {
            count++
          }
        }
        if (count === index) {
          return true
        }
      } else {
        return false
      }
    },
    toggleExpandAll() {
      this.expandAll = !this.expandAll
    },
  },
}
</script>

<style>
@import './styles.scss';
</style>
